export default __webpack_public_path__ + "static/media/step1.3c2b90ac.png";